import gsap from "gsap";

class Cart {
    features = [];
    bundle = '';
    itemList = [];
    queryStringItems = [];

    constructor(cart) {
        if (cart) {
            this.deserialize(cart);
            this.generateItemList();
        }
    }

    static isValidCart(item) {
        item = JSON.parse(item);
        if (item && item[0] && item[0][0] === 'features' && item[1] && item[1][0] === 'bundle') {
            return item;
        } else {
            throw new Error('Invalid cart data');
        }
    }

    serialize() {
        return [
            ['features', this.features],
            ['bundle', this.bundle],
        ];
    }

    deserialize(data) {
        this.features = data[0][1];
        this.bundle = data[1][1];
    }

    update(feature, bundle) {
        // If update call includes a bundle, update the bundle.
        if (bundle) {
            this.bundle = bundle
        }

        // If the feature is not in the cart, add it. Otherwise, remove it.
        if (!this.features.includes(feature) && feature !== null) {
            this.features.push(feature);
        } else {
            this.features = this.features.filter(f => f !== feature);
        }

        this.generateItemList();
        return this.serialize();
    }

    remove(feature, bundle) {
        // If update call includes a bundle, remove the bundle.
        if (bundle) {
            this.bundle = '';
        }
        // Remove the feature from the cart.
        this.features = this.features.filter(f => f !== feature);

        this.generateItemList();
        return this.serialize();
    }

    generateItemList() {
        let bundle = this.bundle ? [['bundle', this.bundle]] : [];
        let features = this.features.map(f => ['feature', f]);
        this.itemList = bundle.concat(features);
    }
}

export default {
    cart: null,
    hidden: false,
    queryStringItem: null,

    animateCSS: (element, animation, prefix = 'animate__') => {
        gsap.fromTo('#cart-button', {scale: 0.5}, {scale: 1, duration: 0.5, ease: "bounce"});
    },

    init() {
        this.initiateCart();
    },

    async initiateCart() {
        let localCart = null;
        try {
            localCart = Cart.isValidCart(localStorage.getItem('cart'));
        } catch (e) {
            localCart = null;
        }
        this.cart = new Cart(localCart);
    },

    hideShoppingCart() {
        this.hidden = true;
    },

    isNotEmpty() {
        return (this.cart.features.length > 0 || this.cart.bundle || this.getQueryStringItems());
    },

    hasFeature(feature) {
        return this.cart.features.includes(feature);
    },

    updateCart(e) {
        this.cart.update(e.target.getAttribute('data-cart-value'), e.target.getAttribute('data-package'));
        this.syncToLocalStorage();
        this.animateCSS('#cart-button', 'heartBeat');
    },

    removeFromCart(e) {
        this.cart.remove(e.target.getAttribute('data-cart-value'), e.target.getAttribute('data-package'));
        this.syncToLocalStorage();
        document.getElementById('inquiry_information')._x_model.set(this.toCartInfoList(true));
    },

    syncToLocalStorage() {
        localStorage.setItem('cart', JSON.stringify(this.cart.serialize()));
    },

    toCartInfoList(stringified = false) {
        const itemList = this.getQueryStringItems()
            ? this.cart.itemList.concat([['queryString', this.getQueryStringItems()]])
            : this.cart.itemList;

        return stringified
            ? itemList.map(i => i[1]).join(",")
            : itemList;
    },

    getQueryStringItems() {
        if (this.queryStringItem === null) {
            const queryParams = new URLSearchParams(window.location.search);
            this.queryStringItem = queryParams.get('p') === null
                ? false
                : queryParams.get('p');
        }
        return this.queryStringItem;
    }

}